export const getFeatureStatusByTitle = (data, title) => {
    const result = data.filter((obj) => {
        return obj.title === title;
    });
    
    return result[0] && result[0].flag === 1 ? true : false;
};
  